import axios from "axios";

import {
  createDeleteApiHook,
  createGetApiHook,
  tokenSourceFn,
  createPostApiHook,
  createPatchApiHook,
} from "../apiHooks";
import { API_BASE_URL } from "../axiosConfig";
import { APIResponseType } from "../../../types/generics/APIResponse.type";

const registerBusiness = `business/admin/register`;

const postBusinessTalentEndpoint = `business/account/create`;
const getBusinessAPI = () => `business/admin/me`;

const getBusinessTaasCards = (
  queryParams: Record<string, any> = {},
): string => {
  const fullParams = {
    ...queryParams,
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? 1000,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/taas-cards/business?${queryString}`;
};

const getSingleBusinessTalent = ({ id }: { id: number }) =>
  `/business/account/${id}`;

const updateBusinessAccountEndpoint = "/business/admin/profile";

const getAllBusinessTalents = (
  queryParams: Record<string, any> = {},
): string => {
  const fullParams = {
    ...queryParams,
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? 1000,
    // business_type: queryParams.business_type,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/business/accounts?${queryString}`;
};

// const allBusinessTalentsEndpoint = "/business/accounts";

const updateBusinessTalentEndpoint = ({ id }: { id: number }) =>
  `/business/account/${id}`;

const verifyKYCEndpoint = ({ businessId }: { businessId: number }) =>
  `/business/account/${businessId}/kyc`;

export const useCreateBusinessTalent = createPostApiHook<
  {}, //body
  {}, //path
  APIResponseType<any>
>(postBusinessTalentEndpoint, {
  isFormDataMethod: false,
});

export const useGetBusinessProfile = createGetApiHook<APIResponseType<any>, {}>(
  getBusinessAPI,
);

export const useGetAllBusinessTalents = createGetApiHook<
  APIResponseType<any>,
  {}
>(getAllBusinessTalents);

export const useGetBusinessTaasCards = createGetApiHook<
  APIResponseType<any>,
  {}
>(getBusinessTaasCards);

export const useGetSingleBusinessTalent = createGetApiHook<
  APIResponseType<any>,
  { id: number }
>(getSingleBusinessTalent);

export const useUpdateBusinessProfile = createPatchApiHook<
  {},
  {},
  APIResponseType<any>
>(updateBusinessAccountEndpoint, {
  isFormDataMethod: false,
});

export const useUpdateBusinessTalentProfile = createPatchApiHook<
  {},
  { id: number },
  APIResponseType<any>
>(updateBusinessTalentEndpoint, {
  isFormDataMethod: false,
});

export const useVerifyKYC = createPostApiHook<
  {},
  { businessId: number },
  APIResponseType<any>
>(verifyKYCEndpoint, {
  isFormDataMethod: false,
});

export const useUpdateBusinessKYC = createPatchApiHook<
  {},
  { businessId: number },
  APIResponseType<any>
>(verifyKYCEndpoint, {
  isFormDataMethod: false,
});
